package link.erpango.quip

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.MaterialTheme
import androidx.compose.material.OutlinedTextField
import androidx.compose.material.Snackbar
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.material.TextFieldDefaults
import androidx.compose.material3.IconButton
import androidx.compose.material3.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.lifecycle.viewModelScope
import androidx.navigation.NavController
import androidx.navigation.NavType
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import androidx.navigation.compose.rememberNavController
import androidx.navigation.navArgument
import androidx.savedstate.read
import androidx.compose.runtime.saveable.rememberSaveable
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview

import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.*
import link.erpango.quip.core.SharedFactory
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.domain.entities.DVehicleBrand
import link.erpango.quip.domain.entities.VehicleType
import link.erpango.quip.domain.noteimport.NoteImportTarget
import link.erpango.quip.ui.noteimport.NoteImportBulkScreen
import quip.composeapp.generated.resources.note_import_bulk_entry
import link.erpango.quip.features.garage.GarageViewModel
import link.erpango.quip.features.maintenances.MaintenancesViewModel
import androidx.compose.material.pullrefresh.PullRefreshIndicator
import androidx.compose.material.pullrefresh.pullRefresh
import androidx.compose.material.pullrefresh.rememberPullRefreshState
import androidx.compose.material.ExperimentalMaterialApi
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.ui.AddMaintenanceScreen
import link.erpango.quip.ui.AddSparePartScreen
import link.erpango.quip.ui.AddVehicleScreen
import link.erpango.quip.ui.QuipTopAppBar
import link.erpango.quip.ui.MaintenanceDetailScreen
import link.erpango.quip.ui.MySparePartEditScreen
import link.erpango.quip.ui.MySparePartsListScreen
import link.erpango.quip.ui.ShareMySparePartScreen
import link.erpango.quip.ui.SettingsScreen
import link.erpango.quip.ui.VehicleCard
import link.erpango.quip.ui.VehicleCardList
import link.erpango.quip.ui.VehicleDetailScreen
import link.erpango.quip.ui.VehicleDocumentsScreen
import link.erpango.quip.utils.DatetimeUtils
import link.erpango.quip.utils.PlatformUtils
import link.erpango.quip.ui.LoginScreen
import link.erpango.quip.core.auth.google.googleAuthProvider
import link.erpango.quip.utils.decodeJwt
import org.jetbrains.compose.resources.stringResource
import link.erpango.quip.ui.LoginScreen
import link.erpango.quip.core.auth.google.GoogleAuthProvider
import link.erpango.quip.catalog.CatalogScreen
import link.erpango.quip.catalog.isCatalogEnabled
import link.erpango.quip.features.transfer.TransferViewModel
import link.erpango.quip.ui.transfer.TransferQRScreen
import link.erpango.quip.ui.transfer.ScanQRScreen
import link.erpango.quip.ui.transfer.AcceptTransferScreen
import link.erpango.quip.ui.transfer.PendingTransfersScreen
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import link.erpango.quip.db.QuipDb
import link.erpango.quip.domain.entities.DSparePart
import link.erpango.quip.ui.BackTrigger
import coil3.ImageLoader
import coil3.compose.setSingletonImageLoaderFactory
import coil3.network.ktor3.KtorNetworkFetcherFactory
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun AppScreen(sharedFactory: SharedFactory, pendingVehicleVin: String? = null) {

    setSingletonImageLoaderFactory { context ->
        ImageLoader.Builder(context)
            .components {
                add(KtorNetworkFetcherFactory(sharedFactory.dataSource.remote.garage.api.httpClient))
            }
            .build()
    }

    val garageViewModel: GarageViewModel = sharedFactory.garage.createGarageViewModel()
    val navController = rememberNavController()
    var appBarTitle by remember { mutableStateOf("") }
    // Estado para controlar la visibilidad del botón "atrás" en el AppBar
    var backButtonVisible by remember { mutableStateOf(false) }
    val userName = garageViewModel.userData.collectAsState()

    // Estado para controlar navegación después de operaciones
    var pendingNavigation by remember { mutableStateOf(false) }

    // Estado para controlar la visibilidad del TopBar
    var showTopBar by remember { mutableStateOf(true) }

    Surface(
        color = QuipColors.colorBackground,
        modifier = Modifier.fillMaxSize()
    ) {
        Scaffold(
            containerColor = QuipColors.colorBackground,
            topBar = {
                if (showTopBar) {
                    QuipTopAppBar(
                        tile = appBarTitle,
                        modifier = Modifier.height(64.dp), // Height ajustado para mejor aspecto
                        showBackButton = backButtonVisible,
                        onBack = {
                            navController.popBackStack()
                            // por defecto ocultamos el botón tras pulsar "atrás"
                            backButtonVisible = false
                        },
                        onBackVisibilityChange = { visible -> backButtonVisible = visible }
                    )
                }
            },
            // BottomBar removida
        ) { innerPadding ->
            Box (
                modifier = Modifier.padding(innerPadding)
            ) {

                val authViewModel = sharedFactory.auth.createAuthViewModel()
                val isLoggedInState by authViewModel.hasCredentials.collectAsState()

                // Track which VIN we already navigated to (avoids double navigation)
                val lastHandledVin = remember { androidx.compose.runtime.mutableStateOf<String?>(null) }

                LaunchedEffect(isLoggedInState) {
                    if (isLoggedInState == true) {
                        garageViewModel.refreshUser()
                        // Sincronizar catálogo de marcas/modelos en background
                        launch { sharedFactory.catalogSyncManager.sync() }
                        navController.navigate("home") {
                            popUpTo("login") { inclusive = true }
                        }
                        // Cold start: navigate to vehicle from notification tap
                        val vin = pendingVehicleVin
                        if (vin != null && vin != lastHandledVin.value) {
                            lastHandledVin.value = vin
                            kotlinx.coroutines.delay(300)
                            navController.navigate("vehicle_detail/$vin")
                        }
                    } else if (isLoggedInState == false) {
                        navController.navigate("login") {
                            popUpTo(0) { inclusive = true }
                        }
                    }
                }
                
                // Warm start: app already running when notification is tapped
                LaunchedEffect(pendingVehicleVin) {
                    val vin = pendingVehicleVin ?: return@LaunchedEffect
                    if (vin == lastHandledVin.value) return@LaunchedEffect
                    if (isLoggedInState != true) return@LaunchedEffect
                    lastHandledVin.value = vin
                    navController.navigate("vehicle_detail/$vin")
                }

                val currentRoute = navController.currentBackStackEntryAsState().value?.destination?.route

                NavHost(
                    navController = navController, 
                    startDestination = "login", // Default to login, LaunchedEffect will redirect if needed
                    enterTransition = {
                        slideInHorizontally(
                            initialOffsetX = { it },
                            animationSpec = tween(300)
                        )
                    },
                    exitTransition = {
                        slideOutHorizontally(
                            targetOffsetX = { -it },
                            animationSpec = tween(300)
                        )
                    },
                    popEnterTransition = {
                        slideInHorizontally(
                            initialOffsetX = { -it },
                            animationSpec = tween(300)
                        )
                    },
                    popExitTransition = {
                        slideOutHorizontally(
                            targetOffsetX = { it },
                            animationSpec = tween(300)
                        )
                    }
                ) {
                    composable("login") {
                        showTopBar = false
                        LoginScreen(
                            sharedFactory = sharedFactory,
                            googleAuthProvider = googleAuthProvider,
                            onLoginSuccess = {
                                // Navigation is handled by the LaunchedEffect observing isLoggedInState
                            }
                        )
                    }
                    composable("home") {
                        val baseTitle = stringResource(Res.string.app_top_bar_title_garage)
                        val name = userName.value?.name
                        val homeTitle = if (!name.isNullOrBlank()) "$baseTitle de $name" else baseTitle

                        LaunchedEffect(homeTitle) {
                            appBarTitle = homeTitle
                        }
                        LaunchedEffect(Unit) {
                            backButtonVisible = false
                            showTopBar = false // Disable global top bar for custom design
                        }
                        
                        HomeScreen(
                            innerPadding = PaddingValues(), // Padding handled by Box
                            viewModel = garageViewModel,
                            navController = navController,
                            refreshVehicles = {
                                garageViewModel.fetchGarageFromServer()
                            },
                            title = homeTitle,
                            userId = userName.value?.id
                        )
                    }

                    composable("my_spare_parts") {
                        appBarTitle = stringResource(Res.string.my_spare_parts_title)
                        backButtonVisible = true
                        showTopBar = false // Custom header inside the screen

                        val mySparePartsViewModel = sharedFactory.mySpareParts.createMySparePartsViewModel()
                        val mySparePartsState by mySparePartsViewModel.uiState.collectAsState()
                        val garageVehicles by garageViewModel.vehicles.collectAsState()

                        MySparePartsListScreen(
                            state = mySparePartsState,
                            vehicles = garageVehicles,
                            onSearchQueryChange = { query -> mySparePartsViewModel.onSearchQueryChange(query) },
                            onVehicleFilterChange = { vin -> mySparePartsViewModel.onVehicleFilterChange(vin) },
                            onRefresh = { mySparePartsViewModel.refresh() },
                            onRetry = { mySparePartsViewModel.retry() },
                            onAddPartClick = { navController.navigate("my_spare_part_edit") },
                            onPartClick = { part -> navController.navigate("my_spare_part_edit/${part.id}") },
                            onBackClick = { navController.popBackStack() }
                        )
                    }

                    // Create personal spare part ("My Spare Parts").
                    // Optional preselectVin: arrives from the vehicle detail quick-add with a garage VIN to pre-check.
                    composable(
                        "my_spare_part_edit?preselectVin={preselectVin}",
                        arguments = listOf(
                            navArgument("preselectVin") {
                                type = NavType.StringType
                                nullable = true
                                defaultValue = null
                            }
                        )
                    ) { backStackEntry ->
                        // getStringOrNull: al entrar desde el alta sin VIN el argumento llega ausente o null
                        val preselectVin = backStackEntry.arguments?.read { getStringOrNull("preselectVin") }

                        appBarTitle = stringResource(Res.string.my_spare_parts_title)
                        backButtonVisible = true
                        showTopBar = false // Custom header inside the screen

                        val viewModel = sharedFactory.mySpareParts.createMySparePartEditViewModel(preselectVin = preselectVin)
                        val mySparePartsViewModel = sharedFactory.mySpareParts.createMySparePartsViewModel()
                        val state by viewModel.uiState.collectAsState()
                        val garageVehicles by garageViewModel.vehicles.collectAsState()

                        // Refresh the list and go back once save/delete succeeds (after showing the snackbar).
                        LaunchedEffect(state.saved, state.deleted) {
                            if (state.saved || state.deleted) {
                                delay(1500)
                                mySparePartsViewModel.refresh()
                                navController.popBackStack()
                                viewModel.clearSavedFlags()
                            }
                        }

                        MySparePartEditScreen(
                            state = state,
                            sparePartCatalog = sharedFactory.mySpareParts.sparePartCatalog,
                            garageVehicles = garageVehicles,
                            onCategorySelected = { viewModel.onCategorySelected(it) },
                            onSparePartTypeSelected = { viewModel.onSparePartTypeSelected(it) },
                            onBrandChange = { viewModel.onBrandChange(it) },
                            onModelChange = { viewModel.onModelChange(it) },
                            onReferenceChange = { viewModel.onReferenceChange(it) },
                            onDurabilityDaysChange = { viewModel.onDurabilityDaysChange(it) },
                            onAdditionalInfoChange = { viewModel.onAdditionalInfoChange(it) },
                            onAddCompatibleVehicle = { brandId, modelId -> viewModel.addCompatibleVehicle(brandId, modelId) },
                            onRemoveCompatibleVehicle = { viewModel.removeCompatibleVehicle(it) },
                            onToggleGarageVehicle = { viewModel.toggleGarageVehicle(it) },
                            onSaveClick = { viewModel.save() },
                            onDeleteConfirm = { viewModel.delete() },
                            onBackClick = { navController.popBackStack() },
                            noteImportViewModel = sharedFactory.noteImport.createNoteImportViewModel(NoteImportTarget.SPARE_PART),
                            onSelectGarageVehicle = { viewModel.selectGarageVehicle(it) }
                        )
                    }

                    // Edit personal spare part ("My Spare Parts")
                    composable(
                        route = "my_spare_part_edit/{id}",
                        arguments = listOf(navArgument("id") { type = NavType.LongType })
                    ) { backStackEntry ->
                        val id = backStackEntry.arguments?.read { getLong("id") }
                            ?: throw IllegalArgumentException("Spare part id missing")

                        appBarTitle = stringResource(Res.string.my_spare_parts_title)
                        backButtonVisible = true
                        showTopBar = false // Custom header inside the screen

                        val viewModel = sharedFactory.mySpareParts.createMySparePartEditViewModel(id)
                        val mySparePartsViewModel = sharedFactory.mySpareParts.createMySparePartsViewModel()
                        val state by viewModel.uiState.collectAsState()
                        val garageVehicles by garageViewModel.vehicles.collectAsState()

                        // Refresh the list and go back once save/delete succeeds (after showing the snackbar).
                        LaunchedEffect(state.saved, state.deleted) {
                            if (state.saved || state.deleted) {
                                delay(1500)
                                mySparePartsViewModel.refresh()
                                navController.popBackStack()
                                viewModel.clearSavedFlags()
                            }
                        }

                        MySparePartEditScreen(
                            state = state,
                            sparePartCatalog = sharedFactory.mySpareParts.sparePartCatalog,
                            garageVehicles = garageVehicles,
                            onCategorySelected = { viewModel.onCategorySelected(it) },
                            onSparePartTypeSelected = { viewModel.onSparePartTypeSelected(it) },
                            onBrandChange = { viewModel.onBrandChange(it) },
                            onModelChange = { viewModel.onModelChange(it) },
                            onReferenceChange = { viewModel.onReferenceChange(it) },
                            onDurabilityDaysChange = { viewModel.onDurabilityDaysChange(it) },
                            onAdditionalInfoChange = { viewModel.onAdditionalInfoChange(it) },
                            onAddCompatibleVehicle = { brandId, modelId -> viewModel.addCompatibleVehicle(brandId, modelId) },
                            onRemoveCompatibleVehicle = { viewModel.removeCompatibleVehicle(it) },
                            onToggleGarageVehicle = { viewModel.toggleGarageVehicle(it) },
                            onSaveClick = { viewModel.save() },
                            onDeleteConfirm = { viewModel.delete() },
                            onShareClick = { navController.navigate("my_spare_part_share/$id") },
                            onBackClick = { navController.popBackStack() }
                        )
                    }

                    // Share personal spare part ("My Spare Parts"): clones the part to another user.
                    composable(
                        route = "my_spare_part_share/{id}",
                        arguments = listOf(navArgument("id") { type = NavType.LongType })
                    ) { backStackEntry ->
                        val id = backStackEntry.arguments?.read { getLong("id") }
                            ?: throw IllegalArgumentException("Spare part id missing")

                        appBarTitle = stringResource(Res.string.my_spare_parts_title)
                        backButtonVisible = true
                        showTopBar = false // Custom header inside the screen

                        val viewModel = sharedFactory.mySpareParts.createShareMySparePartViewModel(id, userName.value?.id)
                        val state by viewModel.uiState.collectAsState()

                        ShareMySparePartScreen(
                            state = state,
                            onSearchQueryChange = { viewModel.onSearchQueryChange(it) },
                            onSelectUser = { viewModel.selectUser(it) },
                            onConfirmShareClick = { viewModel.confirmShare() },
                            onLoadUsersRetry = { viewModel.loadUsers() },
                            onShareSuccessDismissed = {
                                viewModel.clearShareResults()
                                navController.popBackStack()
                            },
                            onAlreadySharedDismissed = { viewModel.clearShareResults() },
                            onBackClick = { navController.popBackStack() }
                        )
                    }

                    composable("vehicle_detail/{vin}") { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vin") }
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin ?: "")

                        if (vehicle != null) {
                            appBarTitle = stringResource(Res.string.vehicle_details)
                            backButtonVisible = true
                            showTopBar = false // Disable global top bar for custom design

                            val maintenancesViewModel: MaintenancesViewModel =
                                sharedFactory.garage.createMaintenancesViewModel(vehicle)
                            val maintenances by maintenancesViewModel.maintenances.collectAsState()

                            // Reload maintenances when entering
                            LaunchedEffect(vehicleVin) {
                                maintenancesViewModel.fetchMaintenancesFromServer()
                            }

                            // Personal spare parts linked to this vehicle (one VM per VIN).
                            val vehicleSparePartsViewModel = sharedFactory.mySpareParts.createVehicleMySparePartsViewModel(vehicle.vin)
                            val vehicleSparePartsState by vehicleSparePartsViewModel.uiState.collectAsState()

                            // Reload on entry: no-op the first time (the VM loads itself in init),
                            // but re-fetches when coming back from the edit screen.
                            LaunchedEffect(vehicleVin) {
                                vehicleSparePartsViewModel.refresh()
                            }

                            // Vehicle brand/model catalog to resolve compatible-vehicle chips.
                            var vehicleBrands by remember { mutableStateOf(emptyList<DVehicleBrand>()) }
                            LaunchedEffect(Unit) {
                                vehicleBrands = sharedFactory.mySpareParts.loadVehicleBrands()
                            }

                            VehicleDetailScreen(
                                vehicle = vehicle,
                                maintenances = maintenances,
                                sparePartsState = vehicleSparePartsState,
                                vehicleBrands = vehicleBrands,
                                onMaintenanceClick = { maintenance ->
                                    if (!maintenance.isSigned) {
                                        navController.navigate("editMaintenance/${vehicle.vin}/${maintenance.id}")
                                    } else {
                                        navController.navigate("maintenance_detail/${vehicle.vin}/${maintenance.id}")
                                    }
                                },
                                onAddMaintenanceClick = {
                                    navController.navigate("addMaintenance/${vehicle.vin}")
                                },
                                onEditVehicleClick = {
                                    navController.navigate("editVehicle/${vehicle.vin}")
                                },
                                onShareVehicleClick = {
                                    val vehicleJson = Json.encodeToString(vehicle.copy(maintenances = maintenances))
                                    PlatformUtils.shareJsonData(vehicleJson)
                                },
                                onSignAllClick = {
                                    maintenancesViewModel.signAllMaintenances()
                                },
                                onDocumentsClick = {
                                    navController.navigate("documents/${vehicle.vin}")
                                },
                                onTransferVehicleClick = {
                                    navController.navigate("transfer-qr/${vehicle.vin}")
                                },
                                onAddSparePartClick = {
                                    navController.navigate("my_spare_part_edit?preselectVin=${vehicle.vin}")
                                },
                                onRetrySpareParts = {
                                    vehicleSparePartsViewModel.retry()
                                },
                                onSparePartClick = { part ->
                                    navController.navigate("my_spare_part_edit/${part.id}")
                                },
                                onBackClick = {
                                    navController.popBackStack()
                                }
                            )
                        }
                    }


                    // Transfer QR initiation screen
                    composable("transfer-qr/{vin}") { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vin") }
                            ?: throw IllegalArgumentException("Vehicle VIN wrong")
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin)
                            ?: throw IllegalArgumentException("Vehicle not found")

                        appBarTitle = "Transferir Vehículo"
                        backButtonVisible = true
                        showTopBar = false
                        
                        val transferViewModel: TransferViewModel = 
                            sharedFactory.garage.createTransferViewModel(vehicle.vin)
                        
                        TransferQRScreen(
                            navController = navController,
                            vehicleVin = vehicleVin,
                            viewModel = transferViewModel,
                            onNavigateBack = {
                                navController.popBackStack()
                            }
                        )
                    }

                    // Scan QR screen for accepting transfers
                    composable("scan-qr") {
                        appBarTitle = "Escanear QR"
                        backButtonVisible = true
                        showTopBar = false
                        
                        ScanQRScreen(
                            navController = navController,
                            onResult = { qrString ->
                                val qrData = link.erpango.quip.domain.entities.QRData.fromJson(qrString)
                                if (qrData != null) {
                                    navController.navigate("accept-transfer?token=" + qrData.token)
                                }
                            },
                            onError = { errorMsg ->
                                // Handle scan errors
                            },
                            onNavigateBack = {
                                navController.popBackStack()
                            }
                        )
                    }

                    // Accept transfer screen (with OTP fallback)
                    composable("accept-transfer?token={token}") { backStackEntry ->
                        val token = backStackEntry.arguments?.read { getString("token") }
                        
                        appBarTitle = "Aceptar Transferencia"
                        backButtonVisible = true
                        showTopBar = false
                        
                        val transferViewModel: TransferViewModel = 
                            sharedFactory.garage.createTransferViewModel()
                        
                        AcceptTransferScreen(
                            navController = navController,
                            token = token,
                            viewModel = transferViewModel,
                            onNavigateBack = {
                                navController.popBackStack()
                            }
                        )
                    }

composable("documents/{vin}") { backStackEntry ->
                        val vin = backStackEntry.arguments?.read { getString("vin") } ?: return@composable
                        
                        appBarTitle = "Documents"
                        backButtonVisible = true
                        showTopBar = false

                        VehicleDocumentsScreen(
                            vin = vin,
                            viewModel = garageViewModel,
                            onBack = { navController.popBackStack() }
                        )
                    }

                    composable("settings") {
                        val settingsViewModel = sharedFactory.settings.createSettingsViewModel()
                        appBarTitle = stringResource(Res.string.settings)
                        backButtonVisible = false
                        showTopBar = false // Disable global top bar

                        SettingsScreen(
                            innerPadding = PaddingValues(),
                            viewModel = settingsViewModel,
                            onLogout = {
                                navController.navigate("login") {
                                    popUpTo(0) { inclusive = true } // Clear backstack
                                }
                            },
                            onBack = {
                                navController.popBackStack()
                            },
                            onOpenCatalog = if (isCatalogEnabled) {
                                { navController.navigate("catalog") }
                            } else null,
                        )
                    }

                    composable("catalog") {
                        showTopBar = false
                        CatalogScreen(onBack = { navController.popBackStack() })
                    }

                    // Importar desde nota: vehículos, mantenimientos y repuestos de una vez
                    // fresh=true (tarjeta del garaje) empieza de cero; sin él ("Importar todo"
                    // desde el formulario) se revisa la nota que ya se ha pasado al ViewModel.
                    composable(
                        "note_import?fresh={fresh}",
                        arguments = listOf(navArgument("fresh") {
                            type = NavType.BoolType
                            defaultValue = false
                        })
                    ) { backStackEntry ->
                        val fresh = backStackEntry.arguments?.read { getBooleanOrNull("fresh") } ?: false
                        appBarTitle = stringResource(Res.string.note_import_bulk_entry)
                        backButtonVisible = true
                        showTopBar = false

                        val bulkViewModel = sharedFactory.noteImport.createBulkViewModel()
                        val mySparePartsViewModel = sharedFactory.mySpareParts.createMySparePartsViewModel()
                        // Saveable: a rotation must not restart an import under review.
                        var initialized by rememberSaveable { mutableStateOf(false) }
                        LaunchedEffect(Unit) {
                            if (!initialized) {
                                if (fresh || !bulkViewModel.isStarted) bulkViewModel.start()
                                initialized = true
                            }
                        }

                        NoteImportBulkScreen(
                            viewModel = bulkViewModel,
                            sparePartCatalog = sharedFactory.mySpareParts.sparePartCatalog,
                            onBack = {
                                bulkViewModel.reset()
                                navController.popBackStack()
                            },
                            onFinished = {
                                mySparePartsViewModel.refresh()
                                garageViewModel.refreshDistinctOwners()
                                bulkViewModel.reset()
                                navController.popBackStack("home", inclusive = false)
                            }
                        )
                    }

                    composable("add_vehicle") {
                        appBarTitle = stringResource(Res.string.add_vehicle)
                        backButtonVisible = true
                        showTopBar = false
                        
                        val distinctOwners by garageViewModel.distinctOwners.collectAsState()
                        val noteImportViewModel = sharedFactory.noteImport.createNoteImportViewModel(NoteImportTarget.VEHICLE)
                        val bulkViewModel = sharedFactory.noteImport.createBulkViewModel()

                        AddVehicleScreen(
                            innerPadding = PaddingValues(),
                            viewModel = garageViewModel,
                            onVehicleAdded = {
                                garageViewModel.refreshDistinctOwners()
                                navController.popBackStack()
                            },
                            onBackClick = {
                                navController.popBackStack()
                            },
                            distinctOwners = distinctOwners,
                            noteImportViewModel = noteImportViewModel,
                            ownerSuggestion = userName.value?.name,
                            onImportAllFromNote = { note, draft ->
                                bulkViewModel.start(note, draft)
                                navController.navigate("note_import") {
                                    popUpTo("add_vehicle") { inclusive = true }
                                }
                            }
                        )
                    }
                    composable("editVehicle/{vehicleVin}") { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vehicleVin") }
                            ?: throw IllegalArgumentException("Vehicle VIN wrong")
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin)
                            ?: throw IllegalArgumentException("Vehicle not found")

                        appBarTitle = stringResource(Res.string.edit_vehicle)
                        backButtonVisible = true
                        showTopBar = false
                        
                        val distinctOwners by garageViewModel.distinctOwners.collectAsState()
                        
                        AddVehicleScreen(
                            innerPadding = PaddingValues(),
                            viewModel = garageViewModel,
                            vehicleToEdit = vehicle,
                            onVehicleAdded = {
                                garageViewModel.refreshDistinctOwners()
                                navController.popBackStack()
                            },
                            onBackClick = {
                                navController.popBackStack()
                            },
                            distinctOwners = distinctOwners
                        )
                    }

                    // Pantalla para detalle de mantenimiento
                    composable(
                        route = "maintenance_detail/{vehicleVin}/{maintenanceId}",
                        arguments = listOf(
                            navArgument("vehicleVin") { type = NavType.StringType },
                            navArgument("maintenanceId") { type = NavType.IntType }
                        )
                    ) { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vehicleVin") }
                            ?: throw IllegalArgumentException("Vehicle VIN wrong")
                        val maintenanceId = backStackEntry.arguments?.read { getInt("maintenanceId") } ?: 0
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin)
                            ?: throw IllegalArgumentException("Vehicle not found")
                        val maintenancesViewModel: MaintenancesViewModel =
                            sharedFactory.garage.createMaintenancesViewModel(vehicle)

                        val maintenance = maintenancesViewModel.getMaintenanceById(maintenanceId.toLong())
                            ?: throw IllegalArgumentException("Maintenance not found")

                        appBarTitle = stringResource(Res.string.maintenance_details)
                        backButtonVisible = true
                        showTopBar = false
                        MaintenanceDetailScreen(
                            maintenance = maintenance,
                            onEditClick = {
                                navController.navigate("editMaintenance/${vehicleVin}/${maintenanceId}")
                            },
                            onSignClick = {
                                maintenancesViewModel.signMaintenance(maintenance)
                            },
                            onBackClick = {
                                navController.popBackStack()
                            },
                            onSparePartClick = { sparePart ->
                                if (sparePart.id != null) {
                                    navController.navigate("sparePartDetail/${vehicleVin}/${maintenanceId}/${sparePart.id}")
                                }
                            },
                            onDocumentsClick = {
                                navController.navigate("documents/$vehicleVin")
                            },
                        )
                    }

                    //pantalla para agregar mantenimiento
                    composable("addMaintenance/{vehicleVin}") { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vehicleVin") }
                            ?: throw IllegalArgumentException("Vehicle VIN wrong")
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin)
                            ?: throw IllegalArgumentException("Vehicle not found")
                        val maintenancesViewModel: MaintenancesViewModel =
                            sharedFactory.garage.createMaintenancesViewModel(vehicle)

                        val temporarySpareParts by maintenancesViewModel.temporarySpareParts.collectAsState()
                        val distinctMechanics by maintenancesViewModel.distinctMechanics.collectAsState()
                        val distinctWorkshops by maintenancesViewModel.distinctWorkshops.collectAsState()

                        appBarTitle = stringResource(Res.string.add_maintenance)
                        backButtonVisible = true
                        showTopBar = false
                        // Limpiar repuestos temporales al entrar a añadir nuevo mantenimiento
                        // LaunchedEffect(Unit) {
                        //    maintenancesViewModel.clearTemporarySpareParts()
                        // }
                        
                        // Observar si volvemos de añadir un repuesto
                        // Observar si volvemos de añadir un repuesto
                        val savedStateHandle = backStackEntry.savedStateHandle
                        val newSparePartJson = savedStateHandle.remove<String>("new_spare_part")
                        LaunchedEffect(newSparePartJson) {
                            newSparePartJson?.let { json ->
                                val sparePart = kotlinx.serialization.json.Json.decodeFromString(link.erpango.quip.domain.entities.DSparePart.serializer(), json)
                                maintenancesViewModel.addTemporarySparePart(sparePart)
                            }
                        }

                        AddMaintenanceScreen(
                            vehicle = vehicle,
                            temporarySpareParts = temporarySpareParts,
                            onAddMaintenance = { maintenance, callback ->
                                maintenancesViewModel.addMaintenanceAndNotify(maintenance) { success ->
                                    if (success) {
                                        // Solo navegamos de vuelta si el resultado fue exitoso
                                        pendingNavigation = true
                                        // Refresh autocomplete data after adding
                                        maintenancesViewModel.refreshAutocompleteData()
                                    }
                                    callback(success)
                                }
                            },
                            onNavigateToAddSparePart = {
                                navController.navigate("addSparePart/${vehicleVin}")
                            },
                            onRemoveSparePart = { sparePart ->
                                maintenancesViewModel.removeTemporarySparePart(sparePart)
                            },
                            onBackClick = {
                                maintenancesViewModel.clearTemporarySpareParts()
                                navController.popBackStack()
                            },
                            innerPadding = PaddingValues(),
                            distinctMechanics = distinctMechanics,
                            distinctWorkshops = distinctWorkshops,
                            noteImportViewModel = sharedFactory.noteImport.createNoteImportViewModel(NoteImportTarget.MAINTENANCE),
                            onAddSuggestedSpareParts = { parts ->
                                parts.forEach { maintenancesViewModel.addTemporarySparePart(it) }
                            }
                        )

                        // Realizar navegación pendiente
                        LaunchedEffect(pendingNavigation) {
                            if (pendingNavigation) {
                                // Pequeño retraso para que el usuario vea el mensaje del Snackbar
                                kotlinx.coroutines.delay(1500)
                                navController.popBackStack()
                                pendingNavigation = false
                            }
                        }
                    }

                    // Pantalla para editar mantenimiento
                    composable(
                        route = "editMaintenance/{vehicleVin}/{maintenanceId}",
                        arguments = listOf(
                            navArgument("vehicleVin") { type = NavType.StringType },
                            navArgument("maintenanceId") { type = NavType.IntType }
                        )
                    ) { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vehicleVin") } ?: return@composable
                            //?: throw IllegalArgumentException("Vehicle VIN wrong")
                        val maintenanceId = backStackEntry.arguments?.read { getInt("maintenanceId") } ?: -1
                        if (maintenanceId < 0) return@composable
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin)
                            ?: throw IllegalArgumentException("Vehicle not found")
                        val maintenancesViewModel: MaintenancesViewModel =
                            sharedFactory.garage.createMaintenancesViewModel(vehicle)

                        val maintenanceToEdit = maintenancesViewModel.getMaintenanceById(maintenanceId.toLong())
                            ?: return@composable

                        // Inicializar el ViewModel con los datos del mantenimiento a editar
                        LaunchedEffect(maintenanceToEdit) {
                            maintenancesViewModel.startEditingMaintenance(maintenanceToEdit)
                        }

                        val temporarySpareParts by maintenancesViewModel.temporarySpareParts.collectAsState()
                        val distinctMechanics by maintenancesViewModel.distinctMechanics.collectAsState()
                        val distinctWorkshops by maintenancesViewModel.distinctWorkshops.collectAsState()
                        var onBackActionTrigger: BackTrigger by remember { mutableStateOf(
                            BackTrigger.NO_OP) }

                        // Observar si volvemos de añadir un repuesto
                        val savedStateHandle = backStackEntry.savedStateHandle
                        val newSparePartJson = savedStateHandle.remove<String>("new_spare_part")
                        LaunchedEffect(newSparePartJson) {
                            newSparePartJson?.let { json ->
                                val sparePart = kotlinx.serialization.json.Json.decodeFromString(link.erpango.quip.domain.entities.DSparePart.serializer(), json)
                                maintenancesViewModel.addTemporarySparePart(sparePart)
                            }
                        }

                        appBarTitle = stringResource(Res.string.edit_maintenance)
                        backButtonVisible = true
                        showTopBar = false

                        AddMaintenanceScreen(
                            vehicle = vehicle,
                            maintenanceToEdit = maintenanceToEdit,
                            temporarySpareParts = temporarySpareParts,
                            onAddMaintenance = { maintenance, callback ->
                                maintenancesViewModel.updateMaintenanceAndNotify(maintenance) { success ->
                                    if (success) {
                                        // Solo navegamos de vuelta si el resultado fue exitoso
                                        pendingNavigation = true
                                        // Refresh autocomplete data after editing
                                        maintenancesViewModel.refreshAutocompleteData()
                                    }
                                    callback(success)
                                }
                            },
                            onDeleteMaintenance = { maintenance, callback ->
                                maintenancesViewModel.deleteMaintenanceAndNotify(maintenance, callback)
                            },
                            onNavigateToAddSparePart = {
                                navController.navigate("addSparePart/${vehicleVin}")
                            },
                            onRemoveSparePart = { sparePart ->
                                maintenancesViewModel.removeTemporarySparePart(sparePart)
                            },
                            onBackClick = {
                                maintenancesViewModel.clearTemporarySpareParts()
                                navController.popBackStack()
                            },
                            innerPadding = PaddingValues(),
                            distinctMechanics = distinctMechanics,
                            distinctWorkshops = distinctWorkshops
                        )

                        // Realizar navegación pendiente
                        LaunchedEffect(pendingNavigation) {
                            if (pendingNavigation) {
                                // Pequeño retraso para que el usuario vea el mensaje del Snackbar
                                kotlinx.coroutines.delay(1500)
                                navController.popBackStack()
                                pendingNavigation = false
                            }
                        }
                    }

                    // Nueva pantalla para agregar repuestos
                    composable("addSparePart/{vehicleVin}") { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vehicleVin") }
                            ?: throw IllegalArgumentException("Vehicle VIN wrong")
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin)
                            ?: throw IllegalArgumentException("Vehicle not found")
                        val maintenancesViewModel: MaintenancesViewModel =
                            sharedFactory.garage.createMaintenancesViewModel(vehicle)

                        val catalog by maintenancesViewModel.sparePartCatalog.collectAsState()
                        val distinctBrands by maintenancesViewModel.distinctSparePartBrands.collectAsState()
                        val distinctModels by maintenancesViewModel.distinctSparePartModels.collectAsState()
                        val distinctDurabilityDays by maintenancesViewModel.distinctDurabilityDays.collectAsState()

                        appBarTitle = stringResource(Res.string.add_spare_part)
                        backButtonVisible = true
                        showTopBar = false
                        AddSparePartScreen(
                            catalog = catalog,
                            onAddSparePart = { sparePart ->
                                val json = kotlinx.serialization.json.Json.encodeToString(link.erpango.quip.domain.entities.DSparePart.serializer(), sparePart)
                                navController.previousBackStackEntry?.savedStateHandle?.set("new_spare_part", json)
                            },
                             onGetLastSparePart = suspend { categoryId, sparePartId ->
                                maintenancesViewModel.getLastUsedSparePartForType(categoryId, sparePartId)
                             },
                            onNavigateBack = {
                                navController.popBackStack()
                            },
                            innerPadding = PaddingValues(),
                            distinctBrands = distinctBrands,
                            distinctModels = distinctModels,
                            distinctDurabilityDays = distinctDurabilityDays
                        )
                    }

                    // Spare Part Detail Screen
                    composable(
                        route = "sparePartDetail/{vehicleVin}/{maintenanceId}/{sparePartId}",
                        arguments = listOf(
                            navArgument("vehicleVin") { type = NavType.StringType },
                            navArgument("maintenanceId") { type = NavType.IntType }, // Long passed as string or int? ID is Long. NavType.LongType exists.
                            navArgument("sparePartId") { type = NavType.LongType }
                        )
                    ) { backStackEntry ->
                        val vehicleVin = backStackEntry.arguments?.read { getString("vehicleVin") }
                            ?: throw IllegalArgumentException("Vehicle VIN wrong")
                        val maintenanceId = backStackEntry.arguments?.read { getInt("maintenanceId") } ?: 0
                        val sparePartId = backStackEntry.arguments?.read { getLong("sparePartId") } ?: 0L
                        
                        val vehicle = garageViewModel.getVehicleByVin(vehicleVin)
                            ?: throw IllegalArgumentException("Vehicle not found")
                        val maintenancesViewModel: MaintenancesViewModel =
                            sharedFactory.garage.createMaintenancesViewModel(vehicle)

                        // We need to find the spare part.
                        // Since we reload viewModel, we might need to fetch data or ensure it's loaded.
                        // fetchMaintenancesFromServer() is called in init.
                        
                        val maintenance = maintenancesViewModel.getMaintenanceById(maintenanceId.toLong())
                        val sparePart = maintenance?.spareParts?.find { it.id == sparePartId }
                        
                        if (sparePart != null) {
                            appBarTitle = stringResource(Res.string.spare_part_details)
                            backButtonVisible = true
                            showTopBar = false
                            
                            link.erpango.quip.ui.SparePartDetailScreen(
                                sparePart = sparePart,
                                viewModel = maintenancesViewModel,
                                onBack = { navController.popBackStack() }
                            )
                        } else {
                            // Fallback or loading?
                            // If maintenance is null (not loaded yet), we might show loading or fetch.
                            // But usually cache is there.
                            // For now, if null, pop back
                           LaunchedEffect(Unit) {
                               navController.popBackStack()
                           }
                        }
                    }
                }
            }
        }
    }
}

@OptIn(ExperimentalMaterialApi::class)
@Composable
fun HomeScreen(
    innerPadding: PaddingValues,
    viewModel: GarageViewModel,
    navController: NavController,
    refreshVehicles: () -> Unit = {},
    title: String,
    userId: String? = null,
    onUserIdCopied: () -> Unit = {}
) {
    val vehicleList by viewModel.vehicles.collectAsState()
    val isRefreshing by viewModel.isRefreshing.collectAsState()
    val pullRefreshState = rememberPullRefreshState(isRefreshing, { refreshVehicles() })

    var showCopiedFeedback by remember { mutableStateOf(false) }

    LaunchedEffect(showCopiedFeedback) {
        if (showCopiedFeedback) {
            kotlinx.coroutines.delay(2000)
            showCopiedFeedback = false
        }
    }

    LaunchedEffect(Unit) {
        refreshVehicles()
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(color = QuipColors.colorBackground)
            .padding(innerPadding)
    ) {
        link.erpango.quip.ui.components.QuipTransparentHeader {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.h4,
                    fontWeight = androidx.compose.ui.text.font.FontWeight.Bold,
                    color = QuipColors.colorText
                )

                androidx.compose.material.IconButton(onClick = { navController.navigate("my_spare_parts") }) {
                    Icon(
                        imageVector = Icons.Default.Build,
                        contentDescription = stringResource(Res.string.my_spare_parts_title),
                        tint = QuipColors.colorText
                    )
                }

                androidx.compose.material.IconButton(onClick = { navController.navigate("settings") }) {
                    Icon(
                        imageVector = Icons.Default.Settings,
                        contentDescription = stringResource(Res.string.settings),
                        tint = QuipColors.colorText
                    )
                }
            }
        }

        Box(modifier = Modifier.weight(1f).pullRefresh(pullRefreshState)) {
            VehicleCardList(
                vehicles = vehicleList,
                onVehicleClick = { vehicle ->
                    PlatformUtils.vibrate(true, 60L)
                    navController.navigate("vehicle_detail/${vehicle.vin}")
                },
                onAddVehicleClick = {
                    navController.navigate("add_vehicle")
                },
                onScanQrClick = {
                    navController.navigate("scan-qr")
                },
                onImportFromNoteClick = {
                    navController.navigate("note_import?fresh=true")
                }
            )
            PullRefreshIndicator(
                refreshing = isRefreshing,
                state = pullRefreshState,
                modifier = Modifier.align(Alignment.TopCenter)
            )
        }

        if (userId != null || showCopiedFeedback) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 8.dp),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Surface(
                    shape = androidx.compose.foundation.shape.RoundedCornerShape(12.dp),
                    color = QuipColors.colorPrimary.copy(alpha = 0.08f),
                    modifier = Modifier.clickable {
                        PlatformUtils.copyToClipboard(userId!!)
                        showCopiedFeedback = true
                        onUserIdCopied()
                    }
                ) {
                    Row(
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp),
                        horizontalArrangement = Arrangement.spacedBy(4.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            text = "Tu ID: $userId",
                            style = MaterialTheme.typography.caption,
                            fontWeight = FontWeight.Bold,
                            color = QuipColors.colorPrimary
                        )

                        if (showCopiedFeedback) {
                            Text(
                                text = "✓ Copiado",
                                style = MaterialTheme.typography.caption,
                                color = QuipColors.colorTextSecondary
                            )
                        } else {
                            Text(
                                text = "(toca para copiar)",
                                style = MaterialTheme.typography.caption,
                                color = QuipColors.colorTextSecondary
                            )
                        }
                    }
                }
            }
        }
    }
}




@Composable
@Preview
fun App() {
    MaterialTheme {
        var showContent by remember { mutableStateOf(false) }

        Column(Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            Button(onClick = {

                showContent = !showContent
            }) {
                Text("Click me!")
            }
            AnimatedVisibility(showContent) {
                val greeting = remember { Greeting().greet() }
                Column(Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
                    Image(painterResource(Res.drawable.compose_multiplatform), null)
                    Text("Compose: $greeting")
                }
            }
        }
    }
}


@Preview
@Composable
fun VehicleCardPreview() {
    val sampleVehicle = DVehicle(
        vin = "SB1MA3JE80E025410",
        plate = "3574JZT",
        brand = "Toyota",
        model = "Auris",
        vehicleType = VehicleType.CAR,
        year = 2017,
        color = "Azul",
        owner = "Sergio Martínez",
        engineOil = "0W-20",
        frontTireSize = "205/55 R16 91V",
        rearTireSize = "205/55 R16 91V",
        frontTirePressureBelow160 = 2.3,
        rearTirePressureBelow160 = 2.3,
        frontTirePressureAbove160 = 2.3,
        rearTirePressureAbove160 = 2.3,
        recommendedFuel = "Gasolina",
        engineDetails = "1.2 8NR",
        cylinderCount = 4
    )
    VehicleCard(
        vehicleData = sampleVehicle,
        onClick = {}

    )
}

@Preview
@Composable
fun vehicleListPreview() {
    val sampleVehicles = listOf(
        DVehicle(
            vin = "SB1MA3JE80E025410",
            plate = "3574JZT",
            brand = "Toyota",
            model = "Auris",
            vehicleType = VehicleType.CAR,
            year = 2017,
            color = "Azul",
            owner = "Sergio Martínez",
            engineOil = "0W-20",
            frontTireSize = "205/55 R16 91V",
            rearTireSize = "205/55 R16 91V",
            frontTirePressureBelow160 = 2.3,
            rearTirePressureBelow160 = 2.3,
            frontTirePressureAbove160 = 2.3,
            rearTirePressureAbove160 = 2.3,
            recommendedFuel = "Gasolina",
            engineDetails = "1.2 8NR",
            cylinderCount = 4
        ),
        DVehicle(
            vin = "MLHPC62A1M5102072",
            plate = "2069LSZ",
            brand = "Honda",
            model = "CBR 500RA",
            vehicleType = VehicleType.MOTORCYCLE,
            year = 2020,
            color = "Blanco",
            owner = "Javier Martínez",
            engineOil = "10W-30",
            frontTireSize = "N/A",
            rearTireSize = "N/A",
            frontTirePressureBelow160 = 2.5,
            rearTirePressureBelow160 = 2.5,
            frontTirePressureAbove160 = 2.9,
            rearTirePressureAbove160 = 2.9,
            recommendedFuel = "Gasolina 95",
            engineDetails = "500CC 4T",
            cylinderCount = 2
        ),
        DVehicle(
            vin = "MLHPC62A4K5003131",
            plate = "7609LDP",
            brand = "Honda",
            model = "CBR 500RA",
            vehicleType = VehicleType.MOTORCYCLE,
            year = 2019,
            color = "Rojo",
            owner = "Sergio Martínez",
            engineOil = "10W-30",
            frontTireSize = "N/A",
            rearTireSize = "N/A",
            frontTirePressureBelow160 = 2.5,
            rearTirePressureBelow160 = 2.5,
            frontTirePressureAbove160 = 2.9,
            rearTirePressureAbove160 = 2.9,
            recommendedFuel = "Gasolina 95",
            engineDetails = "500CC 4T",
            cylinderCount = 2
        )
    )
    VehicleCardList(vehicles = sampleVehicles, onVehicleClick = {}, onAddVehicleClick = {})
}